import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useState } from "react";

const AddNewEmailForm: React.FC<IAddNewEmailFormProps> = ({ title, open, submitEmail, onClose }) => {
    const [selectedEmail, setSelectedEmail] = useState<string>("")

    const onSubmit = () => {
        if (selectedEmail !== "") {
            submitEmail(selectedEmail)
            setTimeout(resetForm, 500)
        }
    }

    const resetForm = () => {
        setSelectedEmail("")
    }

    const closeForm = () => {
        onClose()
        setTimeout(resetForm, 500)
    }

    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedEmail(event.target.value as string)
    }

    return (
        <Dialog open={open} fullWidth>
            <DialogTitle>Add {title} Alert Email</DialogTitle>
            <DialogContent>
                <Box>
                    <TextField
                        id={title + "-alert-email-address"}
                        label={"Email Address"}
                        variant="outlined"
                        value={selectedEmail}
                        onChange={handleEmailChange}
                        fullWidth
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button disabled={selectedEmail === ""} onClick={onSubmit}>Submit</Button>
                <Button onClick={closeForm}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}

export interface IAddNewEmailFormProps {
    title: string;
    open: boolean;
    submitEmail: (email: string) => void;
    onClose: () => void;
}

export default AddNewEmailForm;